import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Categories from './pages/Categories';
import CategoryCreate from './pages/CategoryCreate';
import CategoryEdit from './pages/CategoryEdit';
import PromocodeTemplates from './pages/PromocodeTemplates';
import PromocodeTemplateEdit from './pages/PromocodeTemplate';
import AdminUsers from './pages/AdminUsers';
import UserForm from './pages/UserForm';
import TelegramUsers from './pages/TelegramUsers';
import TelegramUserForm from './pages/TelegramUserForm';
import ProtectedRoute from './components/ProtectedRoute';
import { LocaleProvider } from './contexts/LocaleContext';
import { ROUTES } from './constants';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <LocaleProvider>
      <Routes>
        <Route path={ROUTES.LOGIN} element={<Login />} />
        <Route
          path={ROUTES.HOME}
          element={
            <ProtectedRoute>
              <Categories />
            </ProtectedRoute>
          }
        />
        <Route
          path="/category"
          element={<Navigate to={ROUTES.HOME} replace />}
        />
        <Route
          path="/category/create"
          element={
            <ProtectedRoute>
              <CategoryCreate />
            </ProtectedRoute>
          }
        />
        <Route
          path="/category/edit/:id"
          element={
            <ProtectedRoute>
              <CategoryEdit />
            </ProtectedRoute>
          }
        />
        <Route
          path="/category/:id/promocode-templates"
          element={
            <ProtectedRoute>
              <PromocodeTemplates />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.PROMOCODE_TEMPLATES}
          element={
            <ProtectedRoute>
              <PromocodeTemplates />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.PROMOCODE_TEMPLATE_CREATE}
          element={
            <ProtectedRoute>
              <PromocodeTemplateEdit />
            </ProtectedRoute>
          }
        />
        <Route
          path="/promocode-template/edit/:id"
          element={
            <ProtectedRoute>
              <PromocodeTemplateEdit />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.ADMIN_USERS}
          element={
            <ProtectedRoute>
              <AdminUsers />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.ADMIN_USER_CREATE}
          element={
            <ProtectedRoute>
              <UserForm />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.ADMIN_USER_EDIT(':id')}
          element={
            <ProtectedRoute>
              <UserForm />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.TELEGRAM_ACCESS}
          element={
            <ProtectedRoute>
              <TelegramUsers />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.TELEGRAM_ACCESS_CREATE}
          element={
            <ProtectedRoute>
              <TelegramUserForm />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.TELEGRAM_ACCESS_EDIT(':id')}
          element={
            <ProtectedRoute>
              <TelegramUserForm />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to={ROUTES.HOME} replace />} />
      </Routes>
      </LocaleProvider>
    </BrowserRouter>
  );
}

export default App;
